import Axios from "axios";
var ShopAfterSalesService = (function () {
    function ShopAfterSalesService() {
    }
    ShopAfterSalesService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/refund_order/list", { params: params });
    };
    ShopAfterSalesService.prototype.handle = function (params) {
        return Axios.get("supplierclientapi/refund_order/process", { params: params });
    };
    ShopAfterSalesService.prototype.cancel = function (params) {
        return Axios.get("supplierclientapi/refund_order/cancel", { params: params });
    };
    ShopAfterSalesService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/refund_order/detail", { params: params });
    };
    ShopAfterSalesService.prototype.getRefundTypeOption = function (params) {
        return Axios.get("supplierclientapi/refund_order/refund_type_option", { params: params });
    };
    ShopAfterSalesService.prototype.syncOrders = function (params) {
        return Axios.post("supplierclientapi/refund_order/manual_sync", params);
    };
    ShopAfterSalesService.prototype.getRefundPurchaseOrderOrderList = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/get_refund_order_list", { params: params });
    };
    ShopAfterSalesService.prototype.getRefundPurchaseOrderOrderDetail = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/get_refund_order_detail", { params: params });
    };
    ShopAfterSalesService.prototype.saveRefundOrde = function (params) {
        return Axios.post("supplierclientapi/refund_order/save", params);
    };
    ShopAfterSalesService.createInstance = function () {
        ShopAfterSalesService.getInstance();
    };
    ShopAfterSalesService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ShopAfterSalesService;
}());
export default ShopAfterSalesService;
